import { render } from "./HeroiconsSolidLibrary.vue?vue&type=template&id=0aa96a39"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLibrary.vue"]])

export default __exports__